import { ServerAlertAction } from '../types/ServerAlertAction'
import { ServerAlertActionV2 } from '../types/ServerAlertActionV2'
import { VARIANT } from '../types/ServerAlertDataV2';

const hideAlert = (id: string): ServerAlertAction => {
    return { type: 'HIDE_ALERT', data: { message: "", variant: 'error', openSnackbar: false, id } };
}

const hideAlertV2 = (id: string): ServerAlertActionV2 => {
    return { type: 'HIDE_ALERT', data: { message: "", variant: VARIANT.LOGIN_ERROR, openSnackbarV2: false, id } };
}


const serverAlertActions = {
    hideAlert,
    hideAlertV2
}

export default serverAlertActions;